// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.title-header[data-v-3814e581] {\n    font-weight: 300;\n    letter-spacing: 2px;\n    text-transform: uppercase;\n    font-size: 16px;\n}\n.table-item[data-v-3814e581] {\n    cursor: pointer;\n}\n", ""]);
// Exports
module.exports = exports;
